export default __webpack_public_path__ + "static/media/object.a4ac543a.svg";